/** Bengali fallback for pages we author. API-published rules and FAQs are not passed through this. */

export const BN_INFO_TITLES = {
  about_us: 'আমাদের সম্পর্কে',
  contact_us: 'যোগাযোগ',
  privacy_policy: 'গোপনীয়তা নীতি',
  terms_conditions: 'শর্তাবলি',
  rules_regulations: 'নিয়মকানুন',
  responsible_gaming: 'দায়িত্বশীল গেমিং',
  faq: 'সাধারণ প্রশ্ন',
  affiliate: 'অ্যাফিলিয়েট',
  security: 'নিরাপত্তা',
  age_restriction: '১৮+',
  kyc: 'KYC',
  aml: 'AML',
};

export const BN_FAQS = {
  'faq-account-1': {
    question: 'Casino অ্যাকাউন্ট কীভাবে খুলব?',
    answer:
      'Casino ওয়েবসাইট থেকে সাইন আপ খুলুন, রেজিস্ট্রেশন ফর্ম পূরণ করুন এবং বয়সের শর্ত পূরণ করেছেন কি না নিশ্চিত করুন। রেজিস্ট্রেশনের পর লগইন করে গেম দেখতে পারবেন।',
  },
  'faq-account-2': {
    question: 'পাসওয়ার্ড ভুলে গেলে কী করব?',
    answer:
      'লগইন পেজে পাসওয়ার্ড ফেরত আনার সুযোগ থাকলে সেটি ব্যবহার করুন, অথবা অ্যাকাউন্টের সাহায্যের জন্য লাইভ চ্যাটে যোগাযোগ করুন।',
  },
  'faq-casino-1': {
    question: 'Casino-তে কী কী খেলা যায়?',
    answer:
      'Casino-তে স্পোর্টস বেটিং, ক্যাসিনো, লাইভ ক্যাসিনো, ক্র্যাশ, ফিশিং, স্লটস এবং হোমপেজে থাকা অন্যান্য বিনোদন আছে।',
  },
  'faq-slots-1': {
    question: 'স্লট গেম কীভাবে খুঁজব?',
    answer: 'হোমপেজের মেনু থেকে স্লটস ক্যাটাগরি বেছে নিন, তারপর গেম ব্রাউজ করুন বা খুঁজুন।',
  },
  'faq-payment-1': {
    question: 'ডিপোজিট ও উইথড্র কীভাবে হয়?',
    answer:
      'লগইনের পর অ্যাকাউন্টের টুল থেকে ডিপোজিট বা উইথড্র খুলুন এবং যে পেমেন্ট মেথড বেছে নেবেন তার স্ক্রিনের ধাপ অনুসরণ করুন। সর্বশেষ সীমা ও প্রসেসিং নোট ওয়ালেট স্ক্রিনে দেখে নিন।',
  },
  'faq-promotion-1': {
    question: 'প্রমোশন কোথায় দেখব?',
    answer: 'সাইটের মেনু থেকে প্রমোশন খুলুন। যোগ দেওয়ার আগে প্রতিটি অফারের নিয়ম পড়ে নিন।',
  },
  'faq-sports-1': {
    question: 'Casino-তে স্পোর্টস বেটিং আছে?',
    answer: 'হ্যাঁ। হোমপেজের স্পোর্টস ক্যাটাগরি থেকে খেলার ধরন ও প্রোভাইডার দেখুন।',
  },
  'faq-table-1': {
    question: 'টেবিল গেম কোথায়?',
    answer: 'হোমপেজের টেবিল ক্যাটাগরি খুলে টেবিল গেম দেখুন।',
  },
  'faq-lottery-1': {
    question: 'Casino-তে লটারি আছে?',
    answer: 'ক্যাটালগে থাকলে লটারির নাম লটারি ক্যাটাগরিতে দেখা যায়।',
  },
};

function section(title, paragraphs = [], list = null, level = 2) {
  return { title, level, paragraphs, list };
}

export const BN_SECTIONS = {
  about_us: [
    section('Casino ক্যাসিনো সম্পর্কে', [
      'Casino একটি অনলাইন ক্যাসিনো ও স্পোর্টস বেটিং প্ল্যাটফর্ম। যারা সহজ, নিরাপদ ও মসৃণ গেমিং চান তাদের জন্য এটি তৈরি।',
      'খেলোয়াড়রা সহজ গেম, পরিষ্কার বোনাস নিয়ম, দ্রুত ডিপোজিট ও উইথড্র এবং সহায়ক সাপোর্ট চান। Casino এই প্রয়োজনগুলো এক জায়গায় রাখে।',
      'Casino-তে ক্যাসিনো, লাইভ ক্যাসিনো, টেবিল গেম, স্লট, ক্র্যাশ, ফিশিং, স্পোর্টস বেটিং ও প্রমোশন আছে। সাইটটি মোবাইল ও ডেস্কটপ দুটোতেই চলে।',
      'খেলোয়াড়ের নিরাপত্তা গুরুত্বপূর্ণ। Casino অ্যাকাউন্টের কার্যকলাপ সুরক্ষিত রাখতে এবং অভিজ্ঞতা পরিষ্কার রাখতে কাজ করে।',
      'আমাদের মূল লক্ষ্য অনলাইন ক্যাসিনো ও স্পোর্টস বিনোদনকে সহজ করা।',
    ]),
    section('সহজ রেজিস্ট্রেশন ও সহজে খেলা', [
      'নতুন খেলোয়াড় কঠিন ধাপ ছাড়াই Casino শুরু করতে পারেন। রেজিস্ট্রেশন দ্রুত রাখা হয়েছে।',
      'অ্যাকাউন্ট খোলার পর গেম ও প্রমোশন দেখা যায়। সাইট এমনভাবে সাজানো যাতে যা দরকার তা খুঁজে পাওয়া যায়।',
      'গেম, বোনাস ও নিয়ম সম্পর্কে পরিষ্কার তথ্য থাকে, যাতে শুরুর আগে বোঝা যায়।',
      'ডিপোজিট ও উইথড্র ওয়ালেট স্ক্রিনে দেখানো পেমেন্ট অপশন ব্যবহার করে। লেনদেনের আগে স্ক্রিনের ধাপ ও সর্বশেষ নিয়ম দেখে নিন।',
    ]),
    section('Casino কীসের উপর জোর দেয়?', [
      'Casino খেলোয়াড়কে আরও ভালো অভিজ্ঞতা দিতে চায়:',
    ], [
      'স্লট, লাইভ ক্যাসিনো, টেবিল গেম, ক্র্যাশ, ফিশিং, লটারি ও স্পোর্টসসহ নানা গেম',
      'মোবাইল ও ডেস্কটপে মসৃণ খেলা',
      'সহজ রেজিস্ট্রেশন',
      'বোনাস ও প্রমোশনের পরিষ্কার নিয়ম',
      'ডিপোজিট ও উইথড্রের গাইডেড ধাপ',
      'লাইভ চ্যাটের মাধ্যমে সহায়ক কাস্টমার সাপোর্ট',
      'দায়িত্বশীল গেমিং সম্পর্কে সচেতনতা',
    ]),
    section('Casino-তে দায়িত্বশীল গেমিং', [
      'Casino দায়িত্বশীল গেমিংকে সমর্থন করে।',
      'ক্যাসিনো ও স্পোর্টস গেম শুধু বিনোদনের জন্য। এগুলোকে নিশ্চিত আয়ের উপায় ভাবা উচিত নয়।',
      'খেলোয়াড়ের উচিত:',
    ], [
      'নিজের বাজেটের মধ্যে খেলা',
      'গেম ও বোনাসের সব নিয়ম পড়া',
      'হারের পেছনে না ছোটা',
      'দরকার হলে বিরতি নেওয়া',
      'গেমিং চাপের মতো লাগলে থেমে যাওয়া',
      'জুয়ার জন্য কখনো ধার না করা',
    ]),
    section('খেলোয়াড়ের প্রতি আমাদের প্রতিশ্রুতি', [
      'Casino একটি সহজ, নিরাপদ ও আনন্দদায়ক অনলাইন অভিজ্ঞতা দিতে চায়।',
      'পরিষ্কার গেম নিয়ম, অ্যাকাউন্ট সুরক্ষা, সহজ পেমেন্ট ধাপ, সহায়ক সাপোর্ট ও দায়িত্বশীল গেমিংয়ের মাধ্যমে প্ল্যাটফর্ম বোঝা সহজ হোক—এটাই আমরা চাই।',
      'Casino — বুদ্ধিমত্তার সাথে খেলুন, নিরাপদে উপভোগ করুন এবং নিয়ন্ত্রণে থাকুন।',
    ], null, 3),
  ],
  contact_us: [
    section('যোগাযোগ', [
      'Casino সাপোর্ট টিম খেলোয়াড়দের সাহায্য করতে প্রস্তুত।',
      'অ্যাকাউন্ট, ডিপোজিট, উইথড্র, গেম, বোনাস বা নিরাপদ গেমিং নিয়ে প্রশ্ন থাকলে কাস্টমার সাপোর্টে যোগাযোগ করুন।',
      'সবচেয়ে দ্রুত সাহায্যের জন্য Casino ওয়েবসাইটের লাইভ চ্যাট ব্যবহার করুন।',
    ]),
    section('কাস্টমার সাপোর্ট', [
      'লাইভ চ্যাট: দ্রুত সাহায্যের জন্য Casino ওয়েবসাইটে পাওয়া যাচ্ছে।',
      'অতিরিক্ত যোগাযোগের মাধ্যম আনুষ্ঠানিকভাবে প্রকাশ হলে এখানে দেখা যাবে।',
    ], null, 3),
  ],
  privacy_policy: [
    section('গোপনীয়তা নীতি', [
      'ওয়েবসাইট ব্যবহারের সময় আপনি যে তথ্য দেন, Casino তা কীভাবে ব্যবহার করে এই পৃষ্ঠায় তা বলা আছে।',
      'প্ল্যাটফর্ম চালাতে, রিকোয়েস্ট প্রসেস করতে এবং সেবা উন্নত করতে প্রয়োজনীয় অ্যাকাউন্ট ও ব্যবহারের তথ্য Casino রাখে।',
      'অ্যাকাউন্টের বিবরণ ও পেমেন্ট কার্যকলাপ উপযুক্ত প্রযুক্তিগত ও সাংগঠনিক ব্যবস্থায় সুরক্ষিত রাখার চেষ্টা করা হয়।',
      'তথ্য গেম ও ওয়ালেট সুবিধা দিতে, অ্যাকাউন্ট যাচাই করতে, অপব্যবহার ঠেকাতে এবং সাপোর্টের উত্তর দিতে ব্যবহার হতে পারে।',
      'গোপনীয়তার বিস্তারিত আইনি ভাষা Casino কনটেন্ট সিস্টেমে প্রকাশ হলে এখানে দেখা যাবে। তার আগে গোপনীয়তা নিয়ে প্রশ্ন থাকলে লাইভ চ্যাট ব্যবহার করুন।',
    ]),
  ],
  terms_conditions: [
    section('শর্তাবলি', [
      'এই শর্তাবলি Casino ব্যবহারের নিয়ম বর্ণনা করে।',
      'অ্যাকাউন্ট খুলে বা Casino ব্যবহার করে আপনি নিশ্চিত করেন যে আপনি ন্যূনতম বয়স পূরণ করেছেন এবং প্ল্যাটফর্ম আইনসম্মত ও দায়িত্বশীলভাবে ব্যবহার করবেন।',
      'খেলোয়াড়কে সঠিক অ্যাকাউন্ট তথ্য দিতে হবে, লগইন তথ্য সুরক্ষিত রাখতে হবে এবং গেম, প্রমোশন, ডিপোজিট ও উইথড্রের দেখানো নিয়ম মানতে হবে।',
      'প্ল্যাটফর্ম নিরাপদ ও ন্যায্য রাখতে Casino প্রয়োজনে পণ্যের নিয়ম, প্রমোশন ও অ্যাকাউন্ট নিয়ন্ত্রণ আপডেট করতে পারে।',
      'সম্পূর্ণ আইনি শর্ত কনটেন্ট সিস্টেমে প্রকাশ হলে এখানে দেখা যাবে। কোনো গেম, প্রমোশন বা ওয়ালেট স্ক্রিনের নিয়ম এই সারসংক্ষেপের সাথে না মিললে সেই কাজের স্ক্রিনের নিয়মই মানুন।',
    ]),
  ],
  rules_regulations: [
    section('নিয়মকানুন', [
      'অ্যাকাউন্ট খোলা, গেম খেলা, প্রমোশনে যোগ দেওয়া এবং পেমেন্ট ব্যবহারের সময় Casino-এর নিয়ম মানতে হবে।',
      'মূল প্রত্যাশা:',
    ], [
      'Casino অন্য কথা না বললে একজন খেলোয়াড়ের একটি ব্যক্তিগত অ্যাকাউন্ট',
      'নাবালক খেলা নয় — খেলোয়াড়ের বয়স ১৮ বা তার বেশি হতে হবে',
      'বোনাস, পেমেন্ট মেথড বা গেম সিস্টেমের অপব্যবহার নয়',
      'অন্য কাউকে অ্যাকাউন্টের প্রবেশাধিকার না দেওয়া',
      'ডিপোজিট, উইথড্র ও প্রমোশনের স্ক্রিনের সব নিয়ম মানা',
      'সাধ্যের মধ্যে দায়িত্বশীলভাবে খেলা',
    ]),
    section('ন্যায্য খেলা', [
      'খেলোয়াড় ও প্ল্যাটফর্ম সুরক্ষায় Casino অস্বাভাবিক অ্যাকাউন্ট কার্যকলাপ পর্যালোচনা করতে পারে।',
      'কোনো নিয়ম বুঝতে সাহায্য লাগলে লাইভ চ্যাটে যোগাযোগ করুন।',
      'প্রকাশিত সম্পূর্ণ বিধিমালা পাওয়া গেলে এখানে দেখা যাবে।',
    ]),
  ],
  responsible_gaming: [
    section('দায়িত্বশীল গেমিং', [
      'Casino চায় খেলোয়াড় নিয়ন্ত্রণে থেকে বিনোদনের জন্য গেম উপভোগ করুন।',
      'জুয়া আর্থিক সমস্যার সমাধান বা নিশ্চিত আয়ের উপায় নয়।',
    ]),
    section('সহায়ক অভ্যাস', [], [
      'খেলার আগে বাজেট ঠিক করুন এবং তা মেনে চলুন',
      'নিয়মিত বিরতি নিন',
      'হারের পেছনে ছুটবেন না',
      'জুয়ার জন্য ধার করবেন না',
      'দৈনন্দিন প্রয়োজনের টাকা থেকে গেমিং আলাদা রাখুন',
      'খেলা চাপের বা নিয়ন্ত্রণের বাইরে লাগলে সঙ্গে সঙ্গে থামুন',
    ]),
    section('সাহায্য দরকার?', [
      'দায়িত্বশীল গেমিং নিয়ে সাহায্য লাগলে Casino-এর লাইভ চ্যাট খুলে বলুন।',
      'Casino শুধু ১৮ বছর বা তার বেশি বয়সী খেলোয়াড়দের জন্য।',
    ]),
  ],
  affiliate: [
    section('Casino অ্যাফিলিয়েট', [
      'আপনার পরিচিতদের সাথে Casino শেয়ার করুন এবং রেফারেল টুলের মাধ্যমে এগিয়ে যান।',
      'Casino অ্যাকাউন্ট খোলার পর, আপনার অ্যাকাউন্টে রেফারেল সুবিধা চালু থাকলে লগইন করা প্রোফাইলে রেফারেল টুল পাওয়া যায়।',
      'এই পৃষ্ঠা শুধু তথ্যের জন্য। কমিশন হার, পেআউট সময়সূচি ও পার্টনার চুক্তি Casino-এর বিদ্যমান রেফারেল সিস্টেম নিয়ন্ত্রণ করে। এখানে সেগুলো বদলানো হয় না।',
    ]),
    section('কীভাবে শুরু করবেন', [], [
      'Casino অ্যাকাউন্ট খুলুন বা লগইন করুন',
      'সুবিধা থাকলে প্রোফাইলের রেফারেল টুল খুলুন',
      'অনুমোদিত মাধ্যমে আপনার নিজস্ব লিংক শেয়ার করুন',
      'Casino-এর সব নিয়ম ও দায়িত্বশীল প্রচার মেনে চলুন',
    ]),
    section('গুরুত্বপূর্ণ নোট', [
      'রেফারেল টুলে না দেখানো কমিশনের অঙ্ক বানিয়ে প্রচার করবেন না।',
      'অ্যাকাউন্টে রেফারেল টুল না দেখালে লাইভ চ্যাটে সাপোর্টের সাথে কথা বলুন।',
    ]),
  ],
  security: [
    section('নিরাপত্তা', [
      'খেলোয়াড়ের প্রবেশাধিকার সুরক্ষায় Casino অ্যাকাউন্ট নিরাপত্তা নিয়ন্ত্রণ ব্যবহার করে।',
      'পাসওয়ার্ড গোপন রাখুন, প্রোফাইলে থাকা নিরাপত্তা অপশন চালু করুন এবং অস্বাভাবিক কিছু দেখলে লাইভ চ্যাটে জানান।',
    ]),
  ],
  age_restriction: [
    section('১৮+', [
      'Casino শুধু ১৮ বছর বা তার বেশি বয়সী খেলোয়াড়দের জন্য।',
      'Casino ব্যবহার করে আপনি নিশ্চিত করেন যে আপনার এলাকার বয়সের শর্ত আপনি পূরণ করেন।',
    ]),
  ],
  kyc: [
    section('KYC', [
      'প্ল্যাটফর্ম নিরাপদ রাখতে এবং কিছু ওয়ালেট রিকোয়েস্ট প্রসেস করতে Casino পরিচয় বা অ্যাকাউন্ট যাচাই চাইতে পারে।',
      'যাচাই লাগলে অ্যাকাউন্টে দেখানো নির্দেশ বা সাপোর্টের নির্দেশ অনুসরণ করুন।',
    ]),
  ],
  aml: [
    section('AML', [
      'অপব্যবহার ঠেকাতে Casino অস্বাভাবিক পেমেন্ট ও অ্যাকাউন্ট কার্যকলাপ দেখে।',
      'খেলোয়াড়কে নিজের পেমেন্ট তথ্য ব্যবহার করতে হবে এবং সাইটে দেখানো সব ওয়ালেট নিয়ম মানতে হবে।',
    ]),
  ],
};
